import React from 'react';
import { ArrowRight, Truck, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/919967331255', '_blank');
  };

  return (
    <section id="hero" className="relative pt-24 pb-20 md:pt-32 md:pb-28 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-50 via-white to-yellow-50 opacity-70"></div>
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNiIgc3Ryb2tlPSIjRUY0NDQ0IiBzdHJva2Utd2lkdGg9IjAuNSIgb3BhY2l0eT0iMC4xIi8+PC9nPjwvc3ZnPg==')] opacity-30"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6 animate-fade-in">
            <div className="inline-flex items-center space-x-2 bg-red-100 text-red-700 px-4 py-2 rounded-full text-sm font-semibold">
              <Truck className="w-4 h-4" />
              <span>Trusted Logistics Partner</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 leading-tight">
              <span className="text-red-600">MAHESH</span>
              <span className="text-yellow-600">XPRESS</span>
            </h1>

            <p className="text-2xl md:text-3xl text-gray-600 font-medium italic">
              Delivering Trust, Mile After Mile
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              Your reliable logistics partner specializing in Mumbai & Navi Mumbai to Chakan routes. 
              We provide daily full-load services with guaranteed on-time delivery.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={scrollToContact}
                className="bg-red-600 hover:bg-red-700 text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all"
              >
                Get a Quote
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              <Button
                onClick={handleWhatsApp}
                className="bg-green-600 hover:bg-green-700 text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all"
              >
                <Phone className="w-5 h-5 mr-2" />
                WhatsApp Us
              </Button>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              <div>
                <div className="text-3xl font-bold text-red-600">24/7</div>
                <div className="text-sm text-gray-600">Service Available</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-red-600">100%</div>
                <div className="text-sm text-gray-600">Safe Delivery</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-red-600">Daily</div>
                <div className="text-sm text-gray-600">Service Routes</div>
              </div>
            </div>
          </div>

          {/* Right Content - Logo Display */}
          <div className="relative animate-fade-in-delay">
            <div className="relative bg-white rounded-2xl shadow-2xl p-8 transform hover:scale-105 transition-transform duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_c3e4d1ad-70cf-4f68-ba19-cd50fce4c8ed/artifacts/brtpycnt_MaheshXpress_Logo.png"
                alt="MAHESHXPRESS Logo"
                className="w-full h-auto"
              />
            </div>
            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-yellow-400 rounded-full blur-3xl opacity-30 animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-red-400 rounded-full blur-3xl opacity-30 animate-pulse" style={{ animationDelay: '1s' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;